export default {
    find_the_newest_homes_for_sale_in: 'Find the newest homes for sale in',
    reset: 'Reset',
    top_cities_in: 'Top cities in',
    real_estate: 'real estate',
    average_price: 'Average Price:',
    average_price_per_sqft: 'Average Price/sqft:',
    average_days_on_market: 'Average Days on market:',
    view: 'View',
    demand: 'DEMAND',
    all_cities_in: 'All cities in',
    data_based_on_current_averages: '*Data based on current averages',
    price: 'Price*',
    price_per_sqft: 'Price/Sqft*',
    days_on_market: 'Days on market*',
    inventory: 'Inventory',
    homes: 'homes',
    homes_for_sale: 'homes for sale',
    view_less: 'View less',
    view_more: 'View more',
    newest_homes_for_sale: 'Newest',
    all_counties_in: 'All counties in',
    explore_more: 'Explore more',
    neighborhoods: 'neighborhoods',
    explore_unique_neighborhoods: 'Explore the many unique neighborhoods',
    has_to_offer: 'has to offer.',
    view_neighborhoods: 'View neighborhoods',
    zip_codes: 'ZIP Codes',
    find_homes_in_preferred_area: 'Find homes within your preferred area.',
    view_zip_codes: 'View ZIP Codes',
};
